import qs from 'qs';
import { useMutation } from 'react-query';
import { network } from 'services/network';

export const mutationFn = ({ id }: QueryParams) => {
    const querystring = qs.stringify({ id }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/management/deleteProjectWithConstraints${querystring}`;
    return network.post(url).then((response) => response.data);
};

export const useMutationDeleteProject = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    id?: number;
}
